function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { createNanoEvents } from 'nanoevents';
export var WebSocketTransport = /*#__PURE__*/function () {
  function WebSocketTransport(url) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebSocketTransport);

    this.url = url;
    var Impl = opts.websocketImplementation;

    if (Impl) {
      this.Impl = Impl;
    } else if (typeof WebSocket !== 'undefined') {
      this.Impl = WebSocket;
    } else {
      throw new Error('No WebSocket support');
    }

    this.connected = false;
    this.emitter = createNanoEvents();
    var format = opts.format,
        subprotocol = opts.subprotocol;
    this.format = format || 'text';
    this.connectionOptions = opts.websocketOptions;
    this.subprotocol = subprotocol;
  }

  _createClass(WebSocketTransport, [{
    key: "open",
    value: function open() {
      var _this = this;

      if (this.connectionOptions) {
        this.ws = new this.Impl(this.url, this.subprotocol, this.connectionOptions);
      } else {
        this.ws = new this.Impl(this.url, this.subprotocol);
      }

      this.ws.binaryType = 'arraybuffer';
      this.initListeners();
      return new Promise(function (resolve, reject) {
        var unbind = [];
        unbind.push(_this.once('open', function () {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          resolve();
        }));
        unbind.push(_this.once('close', function () {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          reject(Error('WS connection closed'));
        }));
      });
    }
  }, {
    key: "setURL",
    value: function setURL(url) {
      this.url = url;
    }
  }, {
    key: "setParam",
    value: function setParam() {}
  }, {
    key: "send",
    value: function send(data) {
      if (!this.ws || !this.connected) {
        throw Error('WebSocket is not connected');
      } else {
        this.ws.send(data);
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.ws && this.connected) {
        this.onclose();
      }
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      return this.emitter.on(event, callback);
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      var unbind = this.emitter.on(event, function () {
        unbind();
        callback.apply(void 0, arguments);
      });
      return unbind;
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this2 = this;

      this.ws.onerror = function (event) {
        _this2.emitter.emit('error', event.error || new Error('WS Error'));
      };

      this.ws.onclose = function () {
        _this2.onclose();
      };

      this.ws.onmessage = function (event) {
        var data = event.data;

        if (_this2.format === 'binary') {
          data = new Uint8Array(data);
        }

        _this2.emitter.emit('data', data);
      };

      this.ws.onopen = function () {
        _this2.connected = true;

        _this2.emitter.emit('open');
      };
    }
  }, {
    key: "onclose",
    value: function onclose() {
      this.ws.onclose = undefined;
      this.ws.close();
      delete this.ws;
      this.connected = false;
      this.emitter.emit('close');
    }
  }]);

  return WebSocketTransport;
}();